import React, { Component } from 'react'
import ReceiptLine from './ReceiptLine'
import * as resource from '../../constants/Resources'
import { connect } from 'react-redux'
import { getTranslation } from '../../actions/dataActions'
import PropTypes from 'prop-types'
import * as systemSetting from '../../constants/SystemSettings'

class Receipt extends Component {

  render() {
    const { 
      lines,
      fontSize,
      subtotal,
      title,
      customerMessage
    } = this.props;

    const style = {
      fontSize: `${fontSize}px`
    }

    return (
      <div className="receipt-container-customer" style={style}>
        <div className="receipt-header">
          <div className="header-icon">
            <i className="browser icon">&nbsp;</i>
          </div>
          <div className="header-messagecontainer">
            <div>
              {title}
            </div>
            <div>  
              {customerMessage}            
            </div>
          </div>
          <div className="header-icon">
          </div>
        </div>
        <div className="receipt-body-customer">
          {
            lines.map(rec =>
              <ReceiptLine
                key={rec.id}
                lineid={rec.id}
                itemid={rec.itemid}
                description={rec.text}
                configuration={rec.configuration}
                quantity={rec.quantity}
                price={rec.price}
                linetype={rec.linetype}
                editable={rec.editable}
                selected={rec.selected}
                discount={rec.discount}
                simpleSeparator={rec.simpleSeparator}
              />
            )
          }
        </div>
        <div className="receipt-footer">
          <div className="footer-price">
            <div className="price-description">
              {this.props.getTranslation(resource.SUB_TOTAL)}
            </div>
            <div className="price-amount">
              {subtotal.toFixed(2).replace('.', ',')}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Receipt.propTypes = {
  lines: PropTypes.array,
  subtotal: PropTypes.number,
  title: PropTypes.string,
  customerMessage: PropTypes.string
}

function mapStateToProps(state) {
  return {
    fontSize: state.generalState.systemSettings[systemSetting.FONT_SIZE_CUSTOMER_DISPLAY]
  }
}

export default connect(mapStateToProps, { getTranslation })(Receipt)



// WEBPACK FOOTER //
// src/components/CustomerDisplay/Receipt.jsx